import {ErrorHandler, Injectable, Injector, NgZone} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";
import {Router} from "@angular/router";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {delay, retryWhen, scan, tap} from "rxjs/operators";

@Injectable()
export class VisbosErrorHandlerService implements ErrorHandler {

  private router: Router;
  rethrowError = false;

  constructor(private http: HttpClient, private ngRx: NgRedux<IAppState>, private zone: NgZone, private injector: Injector) {
    this.rethrowError = false;

  }

  handleError(error: any, message?: string, successCallback?: (result: any) => any, errorCallback?: (err: Error) => any): void {

    if (this.router == null) {
      this.router = this.injector.get(Router);
    }

    if (!environment.production) {
      this.handleErrorWithDebug(error, message, successCallback, errorCallback);
    } else {
      this.handleErrorSilently(error, message, successCallback, errorCallback);
    }

    if (this.rethrowError) {
      throw error;
    }

  }

  private handleErrorSilently(error: any, message?: string, successCallback?: (result: any) => any, errorCallback?: (err: Error) => any) {
    this.logToApi(error, message ? message : error.message, 'error', successCallback, errorCallback);
  }

  private handleErrorWithDebug(error: any, message?: string, successCallback?: (result: any) => any, errorCallback?: (err: Error) => any) {

    console.group("Uncaught Error in VisBOS:");
    console.error(message ? message : error.message, [error]);
    console.groupEnd();

    if (environment.logErrors) {
      this.logToApi(error, message ? message : error.message, 'error', successCallback, errorCallback);
    }

    if (successCallback) {
      successCallback.call(this, null);
    }

  }

  public logToApi(error?: Error, message?: string, severity: 'error' | 'critical' | 'warning' | 'notice' | 'info' | 'debug' = 'error', successCallback?: (result: any) => any, errorCallback?: (err: Error) => any) {

    this.zone.runOutsideAngular(() => {

      let headers = new HttpHeaders(
        {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        });
      let options = {'headers': headers};

      let data = {
        log_message: message,
        url: this.router.url,
        error_message: error ? error.message : null,
        error_stack: error ? error.stack : null,
        user: this.ngRx.getState().session && this.ngRx.getState().session.user ? this.ngRx.getState().session.user.cuid : null,
        admin_unit: this.ngRx.getState().session ? this.ngRx.getState().session.activeAdminUnit : null,
        session_state: this.ngRx.getState()
      };

      // Login user via REST
      return this.http
        .post(
          environment.logUrl + severity,
          JSON.stringify(data),
          options
        ).pipe(
          retryWhen(errors => errors.pipe(
            tap(e => {
                if (e.status == 404) {
                  throw e;
                }
              }
            ),
            scan<number>((errorCount, err) => {
              if (errorCount >= 5) {
                throw err;
              }
              return errorCount + 1;
            }, 0),
            delay(500)
            )
          )
        )
        .toPromise()
        .then(res => {
          if (successCallback) {
            successCallback.call(this, res)
          } else {
            console.info("Logging to API successful...");
          }
        })
        .catch(err => {
          if (errorCallback) {
            errorCallback.call(this, err);
          } else {
            console.error("Error during logging to API...", [err]);
          }
        });


    });

  }
}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/error-handling/visbos-error-handler.service.ts